import React from "react";
import { ReturnReview } from "../Components";
export const ReturnReviewPage = () => {
  return (
    <>
      <ReturnReview />
    </>
  );
};
